import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <>
            <InfoSection title="Starfsumsókn">
                <p>
                    1819 er alltaf að leita að hæfileikaríkum einstaklingum til að starfa í hópi
                    metnaðarfulls starfsfólks okkar. Ef þú hefur áhuga á því að sækja um starf hjá
                    1819 og telur þig passa inn í okkar liðsheild, þá hvetjum við þig til þess að
                    senda inn ferilskrá.
                </p>
                <p>
                    Vinsamlegast sendu okkur tölvupóst á netfangið,{" "}
                    <a href="mailto:1819@1819.is">1819@1819.is</a>
                </p>
            </InfoSection>
            {/* <InfoSection title="Þjónustufulltrúi í hlutastarf">
                <p>Við leitum eftir þjónustufulltrúa í hlutastarf í símsvörun. </p>
                <h6>Hæfniskröfur</h6>
                <ul>
                    <li>Framúrskarandi þjónustulund</li>
                    <li>Stundvísi, samviskusemi og áreiðanleiki</li>
                    <li>Góð tölvufærni</li>
                    <li>Góð íslensku- og enskukunnátta</li>
                </ul>
                <p>
                    Við viljum heyra frá þér, <a href="mailto:1819@1819.is">1819@1819.is</a>
                </p>
            </InfoSection> */}
        </>
    );
}
export default ServiceNumber;
